// extracted by mini-css-extract-plugin
module.exports = {"content":"VerifyCertificatePage_content__2w-ce","captcha":"VerifyCertificatePage_captcha__B-Fx6","image":"VerifyCertificatePage_image__1iz6c"};